import { defineMessages } from 'react-intl';

// eslint-disable-next-line formatjs/blocklist-elements
export default defineMessages({
    monthly: {
        id: '_.repayment_summary_item.date.monthly',
        defaultMessage: `{monthDay, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} of each month`
    },
    weekly: {
        id: '_.repayment_summary_item.date.weekly',
        defaultMessage: 'every {weekDay}'
    },
    Monday: {
        id: '_.repayment_summary_item.date.monday',
        defaultMessage: 'Monday'
    },
    Tuesday: {
        id: '_.repayment_summary_item.date.tuesday',
        defaultMessage: 'Tuesday'
    },
    Wednesday: {
        id: '_.repayment_summary_item.date.wednesday',
        defaultMessage: 'Wednesday'
    },
    Thursday: {
        id: '_.repayment_summary_item.date.thursday',
        defaultMessage: 'Thursday'
    },
    Friday: {
        id: '_.repayment_summary_item.date.friday',
        defaultMessage: 'Friday'
    },
    Saturday: {
        id: '_.repayment_summary_item.date.saturday',
        defaultMessage: 'Saturday'
    },
    Sunday: {
        id: '_.repayment_summary_item.date.sunday',
        defaultMessage: 'Sunday'
    }
});
